import classNames from "classnames";

import gdprCSS from "./Gdpr.module.css";

function TermsAndCond() {
  return (
    <div className={classNames("u-flex", "u-flex-column", "u-bg-background", gdprCSS.backImg)}>
      <div className="u-ml15per u-mr15per mobile-margin u-mt80px u-mb80px">
        <h3 className="u-t-primary u-t-w400">Uvjeti i pravila korištenja</h3>
        <h3 className="u-t-primary u-t-w400 u-ml40px">Temeljne odredbe</h3>
        <ol>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px u-ml20px">
              Uvjeti i pravila korištenja vrijede za korištenje <span className="u-t-w700">Info totema</span>{" "}
              <a className="u-t-primary u-t-w400 u-cursor-pointer" href="www.knauf.hr/Totem">
                www.knauf.hr/Totem
              </a>{" "}
              i <span className="u-t-w700">Kalkulatora</span>{" "}
              <a className="u-t-primary u-t-w400 u-cursor-pointer" href="https://kalkulator.knauf.hr/pocetna">
                https://kalkulator.knauf.hr/pocetna
              </a>{" "}
              sa svim poddomenama i web stranicama te aplikacijama za mobilne telefone koji pripadaju i nalaze se na domeni knauf.com, dalje u tekstu „Usluge“.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px u-ml20px">
              Putem Info totema korisnik može od društva Knauf dobiti odgovore i pojašnjenja na pojedina tehnička i izvedbena pitanja. Kroz Kalkulator korisnik
              može od partnera društva Knauf dobiti ponudu cijene materijala prema predviđenoj količini utroška materijala dobivenoj korištenjem kalkulatora.
              Info totem i Kalkulator (u daljnjem tekstu „usluge“) su u vlasništvu društva Knauf d.o.o., Uzdolje, Uzdolje polje 91 (u daljnjem tekstu „Knauf“).
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Korisnik je svaka osoba koja pristupa navedenim uslugama, a korisnikom se podrazumijevaju neregistrirani korisnici, registrirani korisnici i
              poslovni subjekti koji se istim uslugama koriste po osnovi ugovornog odnosa s društvom Knauf. Da bi korisnik mogao obje usluge koristiti kompletno
              i do kraja s njihovom stvarnom namjenom i na kraju korištenja dobio traženu informaciju morat će elektronskim putem unutar navedenih aplikacija
              dati i potpisati privolu kojom izričito odobrava korištenje sljedećih osobnih podataka: ime, prezime, naziv obrta, tvrtku trgovačkog društva,
              pravni oblik trgovačkog društva, OIB, adresu, broj telefona i e-mail sa svrhom dobivanja tražene informacije od strane Knaufa ili od strane
              partnera društva Knauf. Potpisom ove privole korisnik daje pristanak i suglasnost da se prikupljeni podaci mogu dostaviti ovlaštenim partnerima
              društva Knauf kao trećim osobama radi slanja tražene informacije.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Podaci odgovornog za zaštitu podataka: Knauf d.o.o., e-mail:{" "}
              <a className="u-t-primary u-t-w400 u-cursor-pointer" href="mailto:upiti-hr@knauf.com">
                upiti-hr@knauf.com.
              </a>
              . Pravo na pristup, brisanje osobnih podataka, ulaganje prigovora, zahtjeva na ograničavanje obrade, prijenosa podataka i povlačenje privole na
              obradu osobnih podataka moguće je ostvariti slanjem e-maila na:{" "}
              <a className="u-t-primary u-t-w400 u-cursor-pointer" href="mailto:upiti-hr@knauf.com">
                upiti-hr@knauf.com.
              </a>
              . Svoj pristacnak na obradu osobnih podataka možete povući u bilo kojem trenutku. Prikupljeni osobni podaci kroz navedene usluge neće biti javno
              objavljeni, a sačuvat ćemo ih na vrijeme do tri godine za slučaj eventualnih reklamacija i / ili sudskih sporova nakon čega će isti biti izbrisani
              bez ikakve daljnje odgode. U slučaju korisnikovog opoziva, privole, prikupljeni osobni podaci bit će izbrisani odmah i bez ikakve daljnje odgode
              odmah po primitku korisnikovog opoziva privole. Korisnik u svakom pojedinom slučaju opravdane sumnje da obrada osobnih podataka nije izvršena
              transparentno ima pravo podnošenja prigovora Agenciji na zaštitu osobnih podataka.
            </p>
          </li>
          <h3 className="u-t-primary u-t-w400">Opće odredbe</h3>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Pristupanjem ovim stranicama prihvaćate sva pravila i uvjete korištenja navedenih usluga. Zadržavamo pravo promjena, modifikacija i dopuna uvjeta
              korištenja ovih stranica u bilo kojem trenutku. Promjene stupaju na snagu u trenutku objave. Korisnik je dužan redovito čitati Uvjete i pravila
              korištenja te se smatra da je pristupanjem Info totemu i Kalkulatoru upoznat s aktualnim pravilima i uvjetima njihova korištenja kao i pravilima
              zaštite osobnih podataka.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              U svrhu korištenja usluga korisnik se obvezuje registrirati, zatim dati jasnu i nedvosmislenu privolu za obradu osobnih podataka kako je navedeno
              u samom tekstu privole i u točki 3 ovih Uvjeta i pravila korištenja te nakon davanja privole nastaviti popunjavati registracijski obrazac i u
              registracijskom obrascu popuniti potrebne podatke i podatke za kontakt: ime, prezime, naziv obrta, tvrtku trgovačkog društva, pravni oblik
              trgovačkog društva, OIB, adresu, broj telefona, e-mail. Prikupljanje traženih podataka provodi se sukladno potrebama usluge za čije se korištenje
              korisnik registrirao. Usluge Info totema i Kalkulatora nisu predviđene za osobe mlađe od 16 (šesnaest) godina.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Korisnik za točnost dostavljenih podataka jamči kaznenom i materijalnom odgovornošću te je obvezan održavati podatke točnim i ažurnim. Korisnik
              registracijom na jednu od gore navedene dvije usluge dopušta pohranu, uporabu i obradu navedenih podataka u svrhu njihovog djelovanja, slanja
              sistemskih poruka i komunikaciju s korisničkom podrškom putem elektroničke pošte i telefona. Knauf se obvezuje da će te podatke koristiti samo u
              svrhe za koje su dobiveni te u skladu s mjerodavnim propisima, a sve u skladu s danom privolom korisnika.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Korisnik ima pravo u svakom trenutku zatražiti zatvaranje svog korisničkog računa i brisanje podataka. Knauf će zatvoriti korisnički račun tog
              korisnika u najkraćem mogućem roku nakon podnošenja zahtjeva.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf vodi računa o zaštiti osobnih podataka sukladno primjenjivim propisima i s njima usklađenim vlastitim politikama privatnosti kojima se
              detaljnije uređuju prikupljanje osobnih podataka, njihovo korištenje, sigurnost, čuvanje, brisanje, prijenos te korištenje alata. Poslovni
              subjekti koji su korisnici Knauf usluga u potpunosti su odgovorni za osobne podatke koje prikupljaju i unose, te su dužni upoznati osobe čije
              podatke unose sa svrhom i pravnom osnovom obrade njihovih podataka. Poslovni subjekti su isključivo odgovorni za sadržaj i točnost unesenih
              osobnih podataka, a fizičke osobe koje u ime poslovnog subjekta koriste Knauf usluge sva prava mogu ostvariti putem podataka za kontakt koji su
              navedeni uz korisnički račun.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Korisnik je dužan brinuti se o sigurnosti svoje korisničke lozinke i povremeno je mijenjati. Korisnik je u potpunosti odgovoran za svu štetu
              nastalu neovlaštenim korištenjem prava pristupa, kao i sve sadržaje objavljene pod njegovim korisničkim imenom. Knauf ne odgovara za slučajeve
              zlouporabe korisničke lozinke, ali čim korisnik javi o vjerojatnoj zluporabi, može odgovarajuće postupati.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf je ovlašten u svakom trenutku zatvoriti korisnički račun onih korisnika usluga koji krše ove Uvjete i pravila korištenja ili na neki drugi
              način usporavaju ili ometaju rad jedne ili obje ovim Uvjetima i pravilima reguliranih usluga.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf zadržava pravo, uz zatvaranje korisničkog računa, poduzeti i druge odgovarajuće mjere protiv korisnika koji krše ove Uvjete i pravila
              korištenja. Uvjeti i odnosi između korisnika i društva Knauf podliježu zakonima Republike Hrvatske. U slučaju spora nadležan je Trgovački sud u
              Zagrebu.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Za svaki od upita (u daljnjem tekstu: sadržaj) kreiran na stranicama usluga, prenesen preko stranica ili slično, isključivo odgovara osoba od koje
              je takav sadržaj potekao. Knauf ne daje nikakva jamstva o pitanju točnosti, potpunosti ili autentičnosti takvog sadržaja. U slučaju bilo kakvih
              zahtjeva trećih osoba po osnovi naknade štete ili po bilo kojoj drugoj osnovi, a koja bi bila u vezi sa sadržajem dostavljenim od korisnika,
              korisnik u cijelosti preuzima odgovornost, kao i obvezu poduzeti sve radnje kako bi obranio i zaštitio Knauf od svih takvih zahtjeva. Korisnik se
              obvezuje nadoknaditi Knaufu svaki trošak kao i svu štetu koja bi nastala na temelju zahtjeva trećih osoba, a po bilo kojoj osnovi vezanoj uz
              materijal dostavljen od korisnika.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Zabranjeno je kreiranje i slanje sadržaja unutar upita koji su nezakoniti, štetni, prijeteći, koji zlostavljaju, uznemiravaju, kleveću ili su na
              bilo koji način štetni malodobnim osobama. Nedopušteni su sadržaji koji sadrže osobne podatke drugih osoba bez njihova izričitog odobrenja.
              Korisnik se obvezuje da neće objavljivati sadržaj koji je u suprotnosti sa zakonom, ostalim propisima i Ustavom Republike Hrvatske. Korisnik se
              posebno obvezuje da neće koristiti upite za prodaju robe ili pružanje usluga kojima bi se kršila autorska i srodna prava trećih osoba.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Svi eventualni sporovi nastali iz odnosa korisnika usluga i partnera (nastali zbog istinitosti podataka o korisniku ili sadržaju upita, i sl.)
              rješavaju se isključivo između korisnika i partnera Knaufa. Knauf nije odgovoran ni za kakvu štetu bilo koje vrste, nastale kao posljedica takvih
              odnosa.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              16. Kako bi unaprijedio svoju uslugu Knauf upotrebljava i analizira podatke o poslanim upitima korisnika
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Nije dopušteno kopiranje i uporaba bilo kojeg dijela stranice, uključivši podatke koje daju korisnici, bez prethodnog pismenog dopuštenja društva
              Knauf.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf ne odgovara za bilo kakvu štetu koja bi mogla nastati zbog prekida dostupnosti, neobjavljivanja, odnosno brisanja sadržaja ili zlouporabe
              podataka.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf ne odgovara za bilo kakve troškove koji bi mogli nastati korisniku, a koji mogu nastati zbog korištenja jedne ili obje ovim Uvjetima i
              pravilima reguliranih usluga.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Obje usluge sadrže poveznice na internetske stranice drugih poslužitelja. Knauf ne odgovara za sadržaj internetskih stranica treće strane, ne
              jamči i ne preuzima odgovornost za štetan, ilegalni sadržaj ili druge povrede zakona počinjene na internetskim stranicama trećih strana. Knauf će
              u najkraćem mogućem vremenu ukloniti bilo koju poveznicu ili sadržaj nakon što se u potpunosti uvjeri da on krši pozitivne zakonske propise ili je
              na bilo koji način štetan ili nepoželjan.
            </p>
          </li>
          <h3 className="u-t-primary u-t-w400">Predaja upita</h3>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Skeniranjem QR koda na Info totemu u kategoriji „Pitanja i odgovori“ otvara se kontakt forma u koju korisnik unosi tražene osobne podatke i šalje
              upit Knaufu. Na navedeni upit Knauf odgovara povratnim mailom ili telefonskim pozivom.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Kalkulator je namijenjen za slanje upita prema partnerima društva Knauf, a odnosi se na proračun potrebne količine materijala i njihovu cijenu.
              Skeniranjem QR koda na Info totemu u kategoriji „Kalkulator“ odlazi se na web kalkulator putem kojeg je moguće izraditi kalkulaciju utroška
              materijala. Nakon odabira sustava unutar kalkulatora, kreira se dokument upita za ponudom u kojem se nalazi ispis svih materijala iz sustava koje
              je korisnik odabrao. Prije slanja navedenog dokumenta partneru društva Knuaf na mail adresu, potrebno je obaviti registraciju ili prijavu putem
              kontakt forme. Po zaprimanju upita za ponudom, partner društva Knauf šalje odgovor mailom koji sadrži ponudu s cijenama prema kalkulaciji utroška
              materijala.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Slanjem upita korisnik, nakon prethodnog davanja privole za obradu osobnih podataka iz točke 3 ovih Uvjeta i pravila korištenja, pristaje da se uz
              njegov upit partneru dostave i osobni podaci kako ih je naveo i podesio u postavkama ili upisao u sadržaj upita, a sve u skladu s točkom 5 ovih
              Uvjeta i pravila korištenja i samom prethodno danom privolom. Osobne podatke korisnika mogu vidjeti partneri kojima je poslan upit i
              administratori jedne ili obje usluge, ovisno o tome koja je usluga korištena. Korisnik neće moći koristiti niti jednu uslugu do kraja i neće moći
              dobiti tražene informacije bez prethodnog davanja jasne i nedvosmislene privole za obradu osobnih podataka. Korisnik može zatražiti brisanje upita
              bez navođenja razloga na način da se ulogira u svoj korisnički račun i potvrdi brisanje upita.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">Tekst „Vaša poruka“ u sklopu upita mora biti napisana na hrvatskom jeziku.</p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">Upit ne mora sadržavati sve specifične podatke o traženom upitu.</p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Korisnik može imati samo jedno korisničko ime i može predati više upita istom partneru. Nije dopušteno slanje više upita istog ili sličnog
              sadržaja partneru ili partnerima ukoliko se ne radi o stvarnom interesu. Administratori imaju pravo deaktivacije i/ili brisanja korisničkog računa
              korisnika koji ne koristi uslugu u skladu s prethodno opisanim pravilima ili ako nije dao jasnu i nedvosmislenu prethodnu privolu za obradu
              osobnih podataka iz točke 3 ovih Uvjeta i pravila korištenja.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf zadržava pravo brisanja, upita i/ili korisničkog računa koji ne zadovoljavaju određeni kriterij ili su u suprotnosti s ovim pravilima i
              uvjetima iz bilo kojeg razloga.
            </p>
          </li>
          {/* Lista unutar liste */}
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf ima pravo ukloniti, izmijeniti ili odbiti slanje upita, i to bez najave, u sljedećim okolnostima:
            </p>
            <ul>
              <li>
                <p className="u-t-black u-t-w400">
                  kad korisnik na bilo koji način želi nastaviti koristiti jednu ili obje usluge a prethodno na različite neprimjerene načine pokušava zaobići i
                  / ili odbiti prethodno davanje jasne i nedvosmislene privole za obradu osobnih podataka kako je navedeno u samom tekstu privole i u točki 3
                  ovih Uvjeta i pravila korištenja
                </p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad korisnik krši autorska prava i/ili druga prava intelektualnog vlasništva</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">
                  kad upit može uzrokovati štetu i/ili prekršiti prava intelektualnog vlasništva nekom drugom, na bilo koji način
                </p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad upit i/ili sadržaj upita sadrži diskriminirajuće aspekte</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad sadržaj jednog upita sadrži više proizvoda ili usluga koji nisu raspoređeni u ispravne kategorije</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad je upit u bilo kojem smislu uvredljiv</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad je sadržaj ili tekst upita sumnjiv u bilo kojem smislu</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad upit na bilo koji način narušava kvalitetu sadržaja</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad postoji sumnja na zloupotrebu bilo kakve vrste</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">kad potrebna količina proizvoda navedena u upitu nije stvarna</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">
                  Knauf zadržava pravo izmjene i dopune pojedinog upita, a da se pri tome ne mijenja sadržaj predmetnog upita (lektorske intervencije, dopuna
                  podataka i slično).
                </p>
              </li>
            </ul>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Slanjem upita putem navedenih usluga korisnik se obvezuje da će savjesno odgovarati na upite partnera po potrebi. Korisnik mora imati aktivnu
              adresu elektroničke pošte gdje redovito pregledava poštu.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Korisnici svojim upitom daju suglasnost da društvo Knauf sadržaj tih upita koristi, kopira ga, objavljuje te distribuira bez daljnjeg
              prosljeđivanja osobnih podataka korisnika osim ako se osobni podaci ne prosljeđuju partneru društva Knauf radi primitka odgovora mailom koji
              sadrži ponudu sa cijenom prema kalkulaciji utroška materijala kroz kalkulator.
            </p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">
              Knauf ne jamči da će korisnik u svakom trenutku moći pristupiti sadržaju svojeg upita i korisničkom profilu. Radi zaštite korisnika, sprječavanja
              zloporabe komunikacije, otkrivanja neželjene pošte i zlonamjernog softvera i razvoja Knauf proizvoda, Knauf zadržava pravo bez obavijesti:
            </p>
            <ul>
              <li>
                <p className="u-t-black u-t-w400">provjeriti i analizirati sadržaj upita</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">privremeno zadržati poruke upita i odgoditi njihovu isporuku primateljima</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">trajno otkazati isporuku poruka primateljima</p>
              </li>
            </ul>
          </li>
          <h3 className="u-t-primary u-t-w400">Završne odredbe</h3>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">Ovi Uvjeti korištenja primjenjuju se i vrijede od 01.01.2022. godine.</p>
          </li>
          <li className="u-t-primary">
            <p className="u-t-black u-t-w400 u-ml20px">Sve primjedbe uz članak 11a. Zakona o zaštiti potrošača možete dostaviti u pisanom obliku:</p>
            <ul>
              <li>
                <p className="u-t-black u-t-w400">na adresu sjedišta društva: Uzdolje polje 91, Uzdolje polje, Općina Biskupija, 22300 Knin</p>
              </li>
              <li>
                <p className="u-t-black u-t-w400">
                  putem e-pošte na adresu:{" "}
                  <a className="u-t-primary u-t-w400 u-cursor-pointer" href="mailto:uinfo@knauf.com">
                    info@knauf.com
                  </a>
                </p>
              </li>
            </ul>
            <p className="u-t-black u-t-w400 u-ml20px">Odgovor na prigovor obvezujemo se dati u roku određenom Zakonom o zaštiti potrošača.</p>
          </li>
        </ol>
        <h3 className="u-t-primary u-t-w400 u-mb20px">Podaci o upravitelju usluga Info totem i Kalkulator:</h3>
        <h4 className="u-t-primary u-t-w400">Knauf d.o.o.</h4>
        <p className="u-t-black u-t-w400">
          OIB: 46419854204 <br />
          Uzdolje polje 91, Uzdolje polje, Općina Biskupija, 22300 Knin <br />
          E-pošta:{" "}
          <a className="u-t-primary u-t-w400 u-cursor-pointer" href="mailto:uinfo@knauf.com">
            info@knauf.com
          </a>{" "}
          <br />
          Telefon: 01/3035 400 <br />
          Društvo je upisano u sudski registar kod Trgovačkog suda u Zadru, stalna služba u Šibeniku pod matičnim brojem subjekta upisa (MBS): 03085686
        </p>
      </div>
    </div>
  );
}
export default TermsAndCond;
